export default {
  setSettings({commit}, settings) {
    commit('setSettings', settings);
  },
  setSessions({commit}, sessions) {
    commit('setSessions', sessions);
  },
  setAuditor({commit}, object) {
    commit('setAuditor', object);
  },
  setAssignee({commit}, object) {
    commit('setAssignee', object);
  },
  setStartedAt({commit}, value) {
    commit('setStartedAt', value);
  },
  setFinishedAt({commit}, value) {
    commit('setFinishedAt', value);
  },
  setIsSaved({commit}, value) {
    commit('setIsSaved', value);
  },
  setUuid({commit}, value) {
    commit('setUuid', value);
  },
  clearSession({commit}) {
    commit('setSessions', {});
    commit('setUuid', null);
    //commit('setIsSaved', false);
    //commit('setFinishedAt', null);
    //commit('setStartedAt', null);
    //commit('setAssignee', null);
    //commit('setAuditor', null);
    //commit('setSettings', {});
  },
};


// WEBPACK FOOTER //
// ./src/modules/randomRotation/vuex/actions.js